import { createSlice } from '@reduxjs/toolkit';

export const loading = createSlice({
  name: 'loading',
  initialState: {
    counter: 0,
  },
  reducers: {
    setLoading: (state, action) => {
      if (action.payload) {
        state.counter += 1;
      } else {
        state.counter -= 1;
      }
    },
  },
});

export const { setLoading } = loading.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const selectLoadingCounter = (state) => state.loading.counter;

export default loading.reducer;
